function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarkdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 7.955h27v16.091h-27z",
  style: {
    fill: "none",
    stroke: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.909 20.636v-9.272h2.727l2.728 3.409 2.727-3.409h2.727v9.272h-2.727v-5.318l-2.727 3.409-2.728-3.409v5.318zM22.955 20.636l-4.091-4.5h2.727v-4.772h2.727v4.772h2.727z",
  style: {
    fill: "#fff"
  }
}));
export default SvgMarkdown;